import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type ChatSoundStore = {
  soundOn: boolean
  setSoundEnabled: (enabled: boolean) => void
  toggleSound: () => void
}

export const createChatSoundStore = (storeName: string) =>
  create<ChatSoundStore>()(
    devtools(
      persist(
        (set, get) => ({
          soundOn: true,
          setSoundEnabled: (enabled) => set({ soundOn: enabled }),
          toggleSound: () => set({ soundOn: !get().soundOn }),
        }),
        { name: storeName }
      )
    )
  )
type BoundChatSoundStore = ReturnType<typeof createChatSoundStore>
class ChatSoundStores {
  private static _instances: { [key: string]: BoundChatSoundStore } = {}
  private constructor() {}

  public static getInstance(name = 'webchat:soundEnabled'): BoundChatSoundStore {
    if (!ChatSoundStores._instances[name]) {
      ChatSoundStores._instances[name] = createChatSoundStore(name)
    }
    return ChatSoundStores._instances[name]
  }
}
export const getUseChatSoundStore = ChatSoundStores.getInstance
